import { createAction, createReducer } from 'redux-act';

export interface ILocation {
  id: number;
  name: string;
  fullName?: string;
  regionName?: string;
  nameLocative?: string;
  nameGenitive?: string;
  route: string;
  alias: string;
  localityType: string;
  shortLocationType: string;
  latitude: number;
  longitude: number;
}

export interface IState {
  centers: ILocation[];
  currentLocation: ILocation;
}

const initialState: IState = {
  centers: [],
  currentLocation: {
    id: 83,
    name: 'Москва',
    fullName: 'г Москва',
    nameLocative: 'в Москве',
    nameGenitive: 'Москвы',
    route: '6.83.',
    alias: 'moskva',
    localityType: 'город',
    shortLocationType: 'г.',
    latitude: 55.753676,
    longitude: 37.619899,
  },
};

export const setLocations = createAction<ILocation[]>('locations/set');
export const setCurrentLocation = createAction<ILocation>('locations/current/set');

export default createReducer<IState>({}, initialState)
  .on(setLocations, (state, centers) => ({
    ...state,
    centers,
  }))
  .on(setCurrentLocation, (state, currentLocation) => ({
    ...state,
    currentLocation,
  }));
